export const Config = {
  basePath: 'http://116.62.205.12:5021',
  // basePath: 'http://127.0.0.1:5020',
  version: '3.4.0',
};
